import { render, staticRenderFns } from "./AccountIcon.vue?vue&type=template&id=2b7a2d37&scoped=true&"
import script from "./AccountIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AccountIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a2d37",
  null
  
)

export default component.exports